import React from 'react'
import {
  FieldError,
  Radio as AriaRadio,
  RadioGroup as AriaRadioGroup,
  RadioGroupProps as AriaRadioGroupProps,
  Text,
  ValidationResult,
} from 'react-aria-components'

import './RadioGroup.css'
import { Label } from '../Label'

export interface RadioGroupProps extends Omit<AriaRadioGroupProps, 'children'> {
  children?: React.ReactNode
  label?: string
  description?: string
  errorMessage?: string | ((validation: ValidationResult) => string)
  variation?: 'default' | 'segmented'
}

export function RadioGroup({
  label,
  description,
  errorMessage,
  children,
  variation = 'default',
  ...props
}: RadioGroupProps) {
  return (
    <AriaRadioGroup {...props} data-variation={variation}>
      <div className="react-aria-RadioContent">
        {label && <Label>{label}</Label>}
        {children}
      </div>
      {description && <Text slot="description">{description}</Text>}
      <FieldError>{errorMessage}</FieldError>
    </AriaRadioGroup>
  )
}

export const Radio = AriaRadio
